/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AppInputs */

const cs_enum_app = /** @type {(inputs: Enum_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikace`)
};

const en_enum_app = /** @type {(inputs: Enum_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App`)
};

/**
* | output |
* | --- |
* | "App" |
*
* @param {Enum_AppInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_app = /** @type {((inputs?: Enum_AppInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AppInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_app(inputs)
	return cs_enum_app(inputs)
});